__turbopack_context__.v({
  "container": "style-module-scss-module__MydBuG__container",
  "image": "style-module-scss-module__MydBuG__image",
});
